import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import StubIllustration from './svg/stub.svg'

import styles from './Stub.module.scss';

type Props = {
  className?: string
}

export const Stub = ({ className }: Props) => {
  const { t } = useTranslation('finances')
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.message}>{t('save_cards_empty', 'У вас нет сохраненных карт')}</div>
      <StubIllustration />
    </div>
  )
}
